import { useEffect, useMemo, useState } from "react";
import { RealCommerceError } from "../exceptions";
import { useStores } from "../store";
import { useRealCommerceErrorHandling } from ".";
/**
 * Use the `?=user-confirmation-code` parameter and activate the devowl.io account for that purchase.
 */
function useUserConfirmationCode() {
  const {
    accountStore
  } = useStores();
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState();
  const [confirmationToken] = useState(params.get("user-confirmation-code") || undefined);
  const handleRealCommerceError = useRealCommerceErrorHandling();

  // Listen to `?user-confirmation-code=`
  useEffect(() => {
    if (confirmationToken) {
      const post = async () => {
        // Replace current URL without GET parameter
        const newUrl = window.location.href.replace(/([?]?user-confirmation-code=\w{8}-\w{4}-\w{4}-\w{4}-\w{12}[&]?)/gm, "");
        window.history.replaceState({}, document.title, newUrl);
        setBusy(true);
        try {
          setResult(await accountStore.activateUser(confirmationToken));
        } catch (e) {
          if (e instanceof RealCommerceError) {
            handleRealCommerceError(e);
          }
        } finally {
          setBusy(false);
        }
      };
      post();
    }
  }, []);
  return {
    confirmationToken,
    busy,
    result
  };
}
export { useUserConfirmationCode };